import ModalTypes from '../../enums/app/modalTypes';
import {hideModalAction, showHidReconnectModalAction} from '../../state/ducks/modal';
import {dispatch} from '../../state/store';

let isHidReconnectModalActionNeedsToBeCalled = false;
let isHideReconnect = false;

const setCustomOHandler = () => {
    isHideReconnect = true;
    dispatch(hideModalAction(ModalTypes.HID_RECONNECT));
};

const clearCustomHandlerAndShowReconnectModal = () => {
    isHideReconnect = false;

    if (isHidReconnectModalActionNeedsToBeCalled) {
        dispatch(showHidReconnectModalAction());
    }
};

const showHidReconnectModal = () => {
    if (isHideReconnect) {
        isHidReconnectModalActionNeedsToBeCalled = true;
    } else {
        dispatch(showHidReconnectModalAction());
    }
};

const clearHidReconnectHandlerState = () => (isHidReconnectModalActionNeedsToBeCalled = false);

export default {
    showHidReconnectModal,
    setCustomOHandler,
    clearCustomHandlerAndShowReconnectModal,
    clearHidReconnectHandlerState,
};
